const REFINEMENT_HEADER_ELEMENT = 'Web.RefinementInterface.v1_0.RefinementHeaderElement';
export const GALLERY_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.GalleryTemplateInterface.GalleryTemplate';
export const SEARCH_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.SearchTemplateInterface.SearchTemplate';
